import { BookmarksScreen } from '@/components/bookmarks/BookmarksScreen';
import { HelpScoutBeacon } from '@/components/HelpScoutBeacon';
import { formatPageTitle, useDocumentTitle } from '@/hooks/useDocumentTitle';
import React from 'react';

export default function BookmarksPage() {
  useDocumentTitle(formatPageTitle('My Bookmarks'));
  return (
    <>
      <BookmarksScreen />
      <HelpScoutBeacon />
    </>
  );
}
